import { render, staticRenderFns } from "./FileStar.vue?vue&type=template&id=5bf0d4af&scoped=true"
import script from "./FileStar.vue?vue&type=script&lang=js"
export * from "./FileStar.vue?vue&type=script&lang=js"
import style0 from "./FileStar.vue?vue&type=style&index=0&id=5bf0d4af&prod&lang=scss&scoped=true"
import style1 from "./FileStar.vue?vue&type=style&index=1&id=5bf0d4af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0d4af",
  null
  
)

export default component.exports